import { Phone, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "../lib/constants";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] grid grid-cols-2"
    >
      <a
        href={`tel:${COMPANY.phoneTel}`}
        data-testid="sticky-call-now"
        className="flex items-center justify-center gap-2 py-4 bg-brand-blue text-white font-semibold"
      >
        <Phone className="w-5 h-5" /> Call Now
      </a>
      <Link
        to="/contact"
        data-testid="sticky-get-care"
        className="flex items-center justify-center gap-2 py-4 bg-brand-amber text-white font-semibold"
      >
        <MessageSquare className="w-5 h-5" /> Get Care
      </Link>
    </div>
  );
}
